import { HttpClient, HttpStatusCode } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_URL, APP_CONFIG, ConfigSettings, ROUTES } from '@shared/config';
import { LandingModel } from '@shared/models/landing-item.model';
import { LandingAreasMenu } from '@shared/models/landing.model';
import { Observable } from 'rxjs';
import { HttpErrorSkip } from '../../interceptors/http-error/http-error-skip.model';
import { catchError } from 'rxjs/operators';
import {
  LOGIN_ERROR_QUERY_PARAM_NAME,
  LoginErrorType,
} from 'src/app/should-login/should-login.config';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LandingHttpService {
  private readonly orApiUrl: string;

  constructor(
    private http: HttpClient,
    private router: Router,
    @Inject(APP_CONFIG) { orApiUrl }: ConfigSettings
  ) {
    this.orApiUrl = `${orApiUrl}${API_URL.landing}`;
  }

  public getAreaMenu(): Observable<LandingAreasMenu[]> {
    return this.http.get<LandingAreasMenu[]>(`${this.orApiUrl}/areasMenu`, {
      withCredentials: true,
    });
  }

  public isRootLanding(landingId: number): Observable<boolean> {
    return this.http
      .get<boolean>(`${this.orApiUrl}/${landingId}/root`, {
        withCredentials: true,
      })
      .pipe(
        catchError(err => {
          if (err.status === HttpStatusCode.NotFound) {
            return this.router.navigate([
              `${ROUTES.home}${ROUTES.landingNotConfigured}`,
            ]);
          }
          return this.router.navigate([ROUTES.shouldLogin], {
            queryParams: {
              [LOGIN_ERROR_QUERY_PARAM_NAME]: LoginErrorType.FORBIDDEN_CONTENT,
            },
          });
        })
      );
  }

  public getParentLanding(landingId: number): Observable<LandingModel> {
    return this.http.get<LandingModel>(`${this.orApiUrl}/${landingId}/parent`, {
      withCredentials: true,
      headers: {
        [HttpErrorSkip.HEADER_KEY]: new HttpErrorSkip({
          skipStatusCodes: [403],
        }).parseToString(),
      },
    });
  }

  public getParentLandingFromLayout(
    layoutId: number
  ): Observable<LandingModel> {
    return this.http.get<LandingModel>(
      `${this.orApiUrl}/${layoutId}/layout/parent`,
      {
        withCredentials: true,
        headers: {
          [HttpErrorSkip.HEADER_KEY]: new HttpErrorSkip({
            skipStatusCodes: [403],
          }).parseToString(),
        },
      }
    );
  }

  public getParentLandingFromLayouts(
    layoutIds: number[]
  ): Observable<LandingModel> {
    const layoutIdsString = layoutIds.join(',');
    return this.http.get<LandingModel>(
      `${this.orApiUrl}/${layoutIdsString}/layouts/parent`,
      {
        withCredentials: true,
      }
    );
  }
}
